import React from 'react';
import styles from './TextEffectsShook.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';

export type TextEffectsShookProps = TextEffectsSharedProps;

const TextEffectsShook: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared {...props}>
      <div className={styles.container} data-testid={TestIds.viewer.container}>
        <div className={styles.text} data-testid={TestIds.viewer.text}>
          {text}
        </div>
        <div
          className={styles.layer1}
          data-text={text}
          data-testid={TestIds.viewer.layer}
        />
        <div
          className={styles.layer2}
          data-text={text}
          data-testid={TestIds.viewer.layer}
        />
        <div
          className={styles.layer3}
          data-text={text}
          data-testid={TestIds.viewer.layer}
        />
        <div
          className={styles.layer4}
          data-text={text}
          data-testid={TestIds.viewer.layer}
        />
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsShook;
